// This mapping is needed to map the criticality shown in the FE and the query parameter accepted in the BE
export const mapCriticalityToStatus = (criticalityStatus: string[]): string[] | undefined => {
    if (criticalityStatus.length === 0) return undefined;

    return criticalityStatus.map((c) => {
        if (c === 'CRITICAL') return 'DANGER';
        if (c === 'WARNING') return 'WARNING';
        if (c === 'OK') return 'NORMAL';
        return c;
    });
};
